module.exports = __webpack_public_path__ + "img/nephotettix-cincticeps.a43a7b15.jpg";